import React from "react";

function NavBar({ userEmail, onSignOut, theme, toggleTheme }) {
  const initial = (userEmail || "?").trim().charAt(0).toUpperCase();
  return (
    <nav
      className="ce-dash-nav hidden lg:flex items-center fixed top-0 left-0 right-0 z-50 px-6"
      role="banner"
    >
      <div className="ce-dash-nav-inner flex items-center justify-between w-full">
        <a href="/student" className="ce-brand" aria-label="CoursEngage home">
          <img src="/brand-assets/logo-icon.svg" alt="" aria-hidden="true" width="28" height="28" className="ce-logo-mark-img" />
          <span>CoursEngage</span>
          <span
            className="ml-2 text-[0.65rem] uppercase tracking-[0.14em] font-semibold px-2 py-0.5 rounded-full"
            style={{
              color: "var(--muted-color)",
              background: "var(--card-hover-bg)",
              border: "1px solid var(--border-color)",
            }}
          >
            Student
          </span>
        </a>

        <div className="flex items-center gap-2">
          <div className="ce-user-chip" title={userEmail}>
            <span className="ce-avatar">{initial}</span>
            <span className="ce-user-email">{userEmail}</span>
          </div>
          <button
            onClick={toggleTheme}
            className="ce-icon-btn"
            title={theme === "light" ? "Switch to dark" : "Switch to light"}
            aria-label="Toggle theme"
          >
            {theme === "light" ? (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>
            )}
          </button>
          <button
            onClick={onSignOut}
            className="ce-icon-btn"
            title="Sign out"
            aria-label="Sign out"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"/><polyline points="16 17 21 12 16 7"/><line x1="21" y1="12" x2="9" y2="12"/></svg>
          </button>
        </div>
      </div>
    </nav>
  );
}

export default NavBar;
